import {useParams} from 'react-router-dom';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {BulletinForm} from 'src/app/bulletins/BulletinForm/BulletinForm';
import {UserGroupDocumentTitle} from 'src/app/user-groups/userGroupHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const ViewBulletinPage = () => {
  useSetDocumentTitle(UserGroupDocumentTitle);
  const {id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Bulletins}>
      {id !== undefined && <BulletinForm id={Number(id)} mode="view" />}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.BulletinView(':id', ':view'),
  element: <ViewBulletinPage />,
  module: ModuleEnum.Bulletins,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default ViewBulletinPage;
